import React from 'react';
import logo from 'assets/img/logo.png';
import './login-centered-box.layout.style.scss';
export const LoginCenteredBoxLayout = props => {
    const { children } = props;
    return (React.createElement("div", { className: 'login-centered-box-wrapper' },
        React.createElement("div", { className: 'd-flex min-vh-100 justify-content-center align-items-center' },
            React.createElement("div", { className: 'login-centered-box' },
                React.createElement("div", null,
                    React.createElement("div", { className: 'd-flex align-items-center justify-content-center' },
                        React.createElement("img", { src: logo, className: 'img-fluid' })),
                    children)))));
};
